// extracted by mini-css-extract-plugin
export var wrapper = "Map-module--wrapper--2Klmq";
export var inner = "Map-module--inner--u0pAa";
export var details = "Map-module--details--24jZA";
export var iframeWrapper = "Map-module--iframeWrapper--1v7qM";